'use client'

import { useEffect } from 'react'
import { useParams, useRouter } from 'next/navigation'

export default function BookingWorkerPage() {
  const { locale } = useParams<{ locale: string }>()
  const router = useRouter()

  useEffect(() => {
    if (!locale) return
    router.replace(`/${locale}/booking-worker/registration/`)
  }, [locale, router])

  return null
}
